import React, { useEffect, useState, useRef } from 'react';
import GeneratePdf from '../../../../components/GeneratePdf';
import { getFormatedNumber } from '../../../../services/appService';
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { useDispatch, useSelector } from 'react-redux';
import { getCandidateVisaStatusRpt, loadCandidateVisaStatusRpt } from '../../../store/reports';
import Moment from 'react-moment';

const CandidateVisaStatus = () => {
    const [selectedEntityType, setSelectedEntityType] = useState(0);
    const [visaExpired, setVisaExpired] = useState(0);
    const [candidateVisaReports, setCandidateVisaReports] = useState([]);
    const [pdfShowHide, setPdfShowHide] = useState(false);
    const [selectedCol, setSelectedCol] = useState([]);
    const [selectedColData, setSelectedColData] = useState([]);
    const [visaType, setVisaType] = useState("");

    // Live search, loading, and scroll sync states
    const [tableSearchTerm, setTableSearchTerm] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [tableWidth, setTableWidth] = useState(0);
    const topScrollRef = useRef(null);
    const tableWrapperRef = useRef(null);

    const entityTypes = [
        { id: 1, name: "C2C Candidates", pmId: 67 },
        { id: 2, name: "W2 Candidates", pmId: 69 },
        { id: 3, name: "1099 Candidates", pmId: 70 },
    ];

    const visaStatus = [
        { value: "H1B", label: "H1B" },
        { value: "EAD_GC", label: "EAD-GC" },
        { value: "TN", label: "TN" },
        { value: "Green_C", label: "Green Card" },
        { value: "US_Citizen", label: "US Citizen" },
        { value: "H4_EAD", label: "H4 EAD" },
        { value: "F1_OPT", label: "F1-OPT" },
        { value: "F1_CPT", label: "F1-CPT" },
        { value: "L1", label: "L1" },
        { value: "Canadian Citizen", label: "Canadian Citizen" }
    ];

    const candidateVisaStatusRpt = useSelector(getCandidateVisaStatusRpt);
    const dispatch = useDispatch();

    useEffect(() => {
        setCandidateVisaReports(candidateVisaStatusRpt || []);
        setIsLoading(false);
    }, [candidateVisaStatusRpt]);

    const handlepdfShowHide = () => {
        setPdfShowHide(false);
        setSelectedCol([]);
        setSelectedColData([]);
    };

    const handleEntityTypeSelect = (pmId) => {
        setSelectedEntityType(pmId);
        setCandidateVisaReports([]);
        setIsLoading(true);
        dispatch(loadCandidateVisaStatusRpt(pmId, visaExpired, 0, 0));
        setTableSearchTerm("");
    };

    const handleVisaExpiredChange = (e) => {
        const val = parseInt(e.target.value);
        setVisaExpired(val);
        setCandidateVisaReports([]);
        if (selectedEntityType !== 0) {
            setIsLoading(true);
            dispatch(loadCandidateVisaStatusRpt(selectedEntityType, val, 0, 0));
        }
    };

    const handleVisaTypeChange = (e) => {
        setVisaType(e.target.value);
    };

    const getFilteredReports = () => {
        if (!candidateVisaReports) return [];
        return candidateVisaReports.filter(item => {
            const term = tableSearchTerm.toLowerCase();
            const matchesSearch = 
                (item.keyName || "").toLowerCase().includes(term) ||
                (item.keyEmail || "").toLowerCase().includes(term) ||
                (item.keyPhone || "").toLowerCase().includes(term) ||
                String(item.keyId || "").toLowerCase().includes(term);
            
            const matchesVisaType = visaType === "" || item.visaType === visaType;
            
            return matchesSearch && matchesVisaType;
        });
    };

    const filteredReports = getFilteredReports();

    // Stats calculations
    const getKpiStats = () => {
        if (!candidateVisaReports || candidateVisaReports.length === 0) {
            return { totalCount: 0, uniqueVisas: 0, expiredCount: 0, activeCount: 0 };
        }
        const totalCount = candidateVisaReports.length;
        const uniqueVisas = new Set(
            candidateVisaReports.map(x => x.visaType).filter(Boolean)
        ).size;
        
        let expiredCount = 0;
        let activeCount = 0;
        
        candidateVisaReports.forEach((item) => {
            if (item.visaExpiration) {
                const expDate = new Date(item.visaExpiration);
                const today = new Date();
                const expDateOnly = new Date(expDate.toDateString());
                const todayOnly = new Date(today.toDateString());
                
                if (expDateOnly < todayOnly) {
                    expiredCount++;
                } else {
                    activeCount++;
                }
            }
        });
        
        return { totalCount, uniqueVisas, expiredCount, activeCount };
    };

    const { totalCount, uniqueVisas, expiredCount, activeCount } = getKpiStats();

    // Dual scrollbars synchronization
    const handleTopScroll = () => {
        if (topScrollRef.current && tableWrapperRef.current) {
            tableWrapperRef.current.scrollLeft = topScrollRef.current.scrollLeft;
        }
    };

    const handleTableScroll = () => {
        if (topScrollRef.current && tableWrapperRef.current) {
            topScrollRef.current.scrollLeft = tableWrapperRef.current.scrollLeft;
        }
    };

    useEffect(() => {
        const updateWidth = () => {
            const table = document.getElementById("sub_ach_rpt");
            if (table) {
                setTableWidth(table.scrollWidth);
            }
        };
        
        updateWidth();
        const timer = setTimeout(updateWidth, 500);
        
        window.addEventListener("resize", updateWidth);
        return () => {
            window.removeEventListener("resize", updateWidth);
            clearTimeout(timer);
        };
    }, [filteredReports, selectedEntityType]);

    const candidateVisaExportPDF = () => {
        let headers = [
            [
                "ID",
                "Name",
                "Email",
                "Phone",
                "Visa Type",
                "Visa Expiration Date",
                "Visa Status",
            ],
        ];

        let data = [];
        filteredReports.forEach((item) => {
            let visaExpirationStatus = "Data not submitted";
            if (item.visaExpiration) {
                const expDate = new Date(item.visaExpiration);
                const today = new Date();
                const expDateOnly = new Date(expDate.toDateString());
                const todayOnly = new Date(today.toDateString());
                visaExpirationStatus = expDateOnly < todayOnly ? "Expired" : "Active";
            }
            data.push([
                item.keyId || "",
                item.keyName || "",
                item.keyEmail || "",
                item.keyPhone || "",
                visaStatus.find((v) => v.value === item.visaType)?.label || 'N/A',
                item.visaExpiration ? new Date(item.visaExpiration).toLocaleDateString() : 'N/A',
                visaExpirationStatus,
            ]);
        });
        
        setSelectedCol(headers);
        setSelectedColData(data);
        setPdfShowHide(true);
    };

    return (
        <div className="cvs-report-container">
            <style>{`
                .cvs-report-container {
                    font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
                    color: #1e293b;
                    margin-bottom: 2rem;
                }

                /* Visual selector cards */
                .cvs-card-selector {
                    margin-bottom: 24px;
                }

                .cvs-select-card {
                    background: #ffffff;
                    border: 1px solid #e2e8f0;
                    border-radius: 14px;
                    padding: 16px;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    gap: 14px;
                    transition: all 0.22s cubic-bezier(0.4, 0, 0.2, 1);
                    height: 100%;
                    position: relative;
                }

                .cvs-select-card:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 8px 20px -4px rgba(0, 0, 0, 0.04);
                    border-color: #cbd5e1;
                }

                .cvs-select-card.active {
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);
                    border-width: 2px;
                    margin: -1px;
                }

                .cvs-select-card-icon {
                    width: 44px;
                    height: 44px;
                    border-radius: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 18px;
                    flex-shrink: 0;
                }

                .cvs-select-card:hover .cvs-select-card-icon {
                    transform: scale(1.05);
                }

                .cvs-select-card-title {
                    font-size: 13.5px;
                    font-weight: 700;
                    color: #1e293b;
                    margin-bottom: 2px;
                }

                .cvs-select-card-desc {
                    font-size: 11px;
                    color: #64748b;
                    line-height: 1.3;
                }

                /* KPI Metric cards */
                .cvs-kpi-row {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
                    gap: 16px;
                    margin-bottom: 24px;
                }

                .cvs-metric-card {
                    background: #ffffff;
                    border: 1px solid #e2e8f0;
                    border-radius: 12px;
                    padding: 14px 18px;
                    display: flex;
                    align-items: center;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.01);
                }

                .cvs-metric-icon {
                    width: 38px;
                    height: 38px;
                    border-radius: 8px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 16px;
                    margin-right: 14px;
                    background: #f1f5f9;
                    color: #475569;
                    flex-shrink: 0;
                }

                .cvs-metric-val {
                    font-size: 18px;
                    font-weight: 800;
                    color: #0f172a;
                    line-height: 1.1;
                    margin-bottom: 2px;
                }

                .cvs-metric-label {
                    font-size: 10.5px;
                    color: #64748b;
                    font-weight: 600;
                    text-transform: uppercase;
                    letter-spacing: 0.02em;
                }

                /* Controls Layout */
                .cvs-report-controls {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    flex-wrap: wrap;
                    gap: 1rem;
                    margin-bottom: 1.5rem;
                    background-color: #fafbfc;
                    border: 1px solid #e2e8f0;
                    border-radius: 10px;
                    padding: 12px 18px;
                }

                .cvs-controls-group {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    flex-wrap: wrap;
                }

                .cvs-search-wrapper {
                    position: relative;
                    width: 240px;
                }

                .cvs-search-input {
                    width: 100%;
                    padding: 8px 12px 8px 34px;
                    background: #ffffff;
                    border: 1px solid #cbd5e1;
                    border-radius: 8px;
                    font-size: 12.5px;
                    color: #1e293b;
                    transition: all 0.2s ease;
                }

                .cvs-search-input:focus {
                    outline: none;
                    border-color: #4f46e5;
                    box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.15);
                }

                .cvs-search-icon {
                    position: absolute;
                    left: 12px;
                    top: 50%;
                    transform: translateY(-50%);
                    color: #94a3b8;
                    font-size: 12px;
                }

                .cvs-filter-select {
                    height: 35px;
                    border: 1px solid #cbd5e1;
                    border-radius: 8px;
                    padding: 0 10px;
                    font-size: 12.5px;
                    color: #475569;
                    background: #ffffff;
                }

                .cvs-filter-select:focus {
                    outline: none;
                    border-color: #4f46e5;
                }

                .cvs-actions-btns {
                    display: flex;
                    align-items: center;
                }

                .cvs-actions-btns > * {
                    margin-right: 8px !important;
                }

                .cvs-actions-btns > *:last-child {
                    margin-right: 0 !important;
                }

                .cvs-report-btn {
                    height: 35px;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    gap: 6px;
                    padding: 0 14px;
                    border-radius: 8px;
                    font-size: 12.5px;
                    font-weight: 600;
                    cursor: pointer;
                    transition: all 0.15s ease;
                    border: 1px solid #cbd5e1;
                    background: #ffffff;
                    color: #475569;
                }

                .cvs-report-btn:hover:not(:disabled) {
                    background-color: #f8fafc;
                    color: #0f172a;
                    border-color: #94a3b8;
                }

                .cvs-report-btn:disabled {
                    background-color: #f1f5f9;
                    border-color: #e2e8f0;
                    color: #94a3b8;
                    cursor: not-allowed;
                }

                /* Table modifications */
                .cvs-report-table-wrapper {
                    border: 1px solid #e2e8f0;
                    border-radius: 12px;
                    overflow-x: auto;
                    overflow-y: hidden;
                    background: white;
                    box-shadow: 0 4px 12px rgba(0,0,0,0.01);
                }

                .cvs-report-table {
                    width: 100%;
                    border-collapse: collapse;
                    font-size: 13px;
                    text-align: left;
                }

                .cvs-report-table th {
                    background-color: #f8fafc;
                    color: #475569;
                    font-weight: 700;
                    text-transform: uppercase;
                    font-size: 10.5px;
                    letter-spacing: 0.05em;
                    padding: 12px 16px;
                    border-bottom: 2px solid #e2e8f0;
                    white-space: nowrap;
                }

                .cvs-report-table td {
                    padding: 12px 16px;
                    border-bottom: 1px solid #f1f5f9;
                    color: #334155;
                    transition: background-color 0.15s ease;
                    white-space: nowrap;
                }

                .cvs-report-table tr:hover td {
                    background-color: #f8fafc;
                }

                /* Shimmer and Loading Animation */
                @keyframes shimmer {
                  0%   { background-position: -600px 0; }
                  100% { background-position: 600px 0; }
                }

                @keyframes loadingBar {
                  0%   { width: 0%; opacity: 1; }
                  70%  { width: 85%; opacity: 1; }
                  100% { width: 100%; opacity: 0; }
                }

                .wf-loading-bar {
                  position: absolute;
                  top: 0;
                  left: 0;
                  right: 0;
                  height: 3px;
                  background: linear-gradient(90deg, #4f46e5, #0ea5e9, #4f46e5);
                  background-size: 200% 100%;
                  animation: loadingBar 1.6s ease-in-out infinite;
                  z-index: 10;
                }

                .skeleton-cell {
                  display: block;
                  height: 12px;
                  border-radius: 6px;
                  background: linear-gradient(
                    90deg,
                    #f1f5f9 25%,
                    #e2e8f0 50%,
                    #f1f5f9 75%
                  );
                  background-size: 600px 100%;
                  animation: shimmer 1.4s ease-in-out infinite;
                }

                .skeleton-cell.sk-short  { width: 40%; }
                .skeleton-cell.sk-medium { width: 65%; }
                .skeleton-cell.sk-long   { width: 85%; }
                .skeleton-cell.sk-full   { width: 92%; }

                .skeleton-row td {
                  padding: 14px 16px !important;
                }

                /* Enhanced empty state */
                .wf-empty-state {
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  justify-content: center;
                  padding: 50px 24px;
                  text-align: center;
                  gap: 12px;
                }

                .wf-empty-icon {
                  width: 52px;
                  height: 52px;
                  border-radius: 14px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  font-size: 22px;
                  background: linear-gradient(135deg, rgba(79, 70, 229, 0.08) 0%, rgba(14, 165, 233, 0.06) 100%);
                  border: 1px solid rgba(79, 70, 229, 0.12);
                  color: #4f46e5;
                  margin-bottom: 4px;
                }

                .wf-empty-title {
                  font-size: 15px;
                  font-weight: 700;
                  color: #1e293b;
                  margin: 0;
                  width: 100%;
                  text-align: center;
                }

                .wf-empty-desc {
                  font-size: 13px;
                  color: #64748b;
                  margin: 0 auto;
                  line-height: 1.6;
                  text-align: center;
                  width: 100%;
                }

                /* Visa status badges */
                .badge-expired {
                    background-color: rgba(239, 68, 68, 0.09);
                    color: #ef4444;
                    border: 1px solid rgba(239, 68, 68, 0.2);
                    padding: 4px 10px;
                    border-radius: 12px;
                    font-size: 11px;
                    font-weight: 700;
                }

                .badge-active {
                    background-color: rgba(16, 185, 129, 0.09);
                    color: #10b981;
                    border: 1px solid rgba(16, 185, 129, 0.2);
                    padding: 4px 10px;
                    border-radius: 12px;
                    font-size: 11px;
                    font-weight: 700;
                }

                .badge-none {
                    background-color: rgba(100, 116, 139, 0.09);
                    color: #64748b;
                    border: 1px solid rgba(100, 116, 139, 0.2);
                    padding: 4px 10px;
                    border-radius: 12px;
                    font-size: 11px;
                    font-weight: 700;
                }
            `}</style>

            <div className="cvs-card-selector">
                <div className="row">
                    {entityTypes.map((t) => {
                        const isActive = Number(selectedEntityType) === t.pmId;
                        const icons = {
                            67: "fa-building-o",
                            69: "fa-user",
                            70: "fa-user-circle-o"
                        };
                        const colors = {
                            67: "rgba(6, 182, 212, 0.08)",
                            69: "rgba(99, 102, 241, 0.08)",
                            70: "rgba(16, 185, 129, 0.08)"
                        };
                        const borderColors = {
                            67: "#06b6d4",
                            69: "#4f46e5",
                            70: "#10b981"
                        };
                        const activeColor = borderColors[t.pmId];
                        
                        return (
                            <div className="col-md-4 mb-3" key={t.id}>
                                <div 
                                    className={`cvs-select-card ${isActive ? "active" : ""}`}
                                    onClick={() => handleEntityTypeSelect(t.pmId)}
                                    style={isActive ? { borderColor: activeColor, background: colors[t.pmId], borderWidth: "2px" } : {}}
                                >
                                    <div 
                                        className="cvs-select-card-icon"
                                        style={{ 
                                            background: colors[t.pmId], 
                                            color: borderColors[t.pmId] 
                                        }}
                                    >
                                        <i className={`fa ${icons[t.pmId]}`}></i>
                                    </div>
                                    <div className="cvs-select-card-body" style={{ flexGrow: 1, minWidth: 0 }}>
                                        <div className="cvs-select-card-title">{t.name}</div>
                                        <div className="cvs-select-card-desc">
                                            {t.pmId === 67 && "Audit visas for Corp-to-Corp contractors."}
                                            {t.pmId === 69 && "Track work authorization details for W2 staff."}
                                            {t.pmId === 70 && "Verify visa legitimacy for 1099 contractors."}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>

            {selectedEntityType !== 0 && (
                <div className="ach-report-body p-0">
                    <div className="cvs-report-controls">
                        <div className="cvs-controls-group">
                            <div className="cvs-search-wrapper">
                                <i className="fa fa-search cvs-search-icon"></i>
                                <input
                                    type="text"
                                    placeholder="Search by name, email, or phone..."
                                    className="cvs-search-input"
                                    value={tableSearchTerm}
                                    onChange={(e) => setTableSearchTerm(e.target.value)}
                                />
                            </div>

                            <select
                                name="visaTypeFilter"
                                id="visaTypeFilter"
                                className="cvs-filter-select"
                                onChange={handleVisaTypeChange}
                                value={visaType}
                            >
                                <option value="">All Visa Types</option>
                                {visaStatus.map((visa) => (
                                    <option key={visa.value} value={visa.value}>{visa.label}</option>
                                ))}
                            </select>

                            <select
                                name="insuranceExpired"
                                id="insuranceExpired"
                                className="cvs-filter-select"
                                onChange={handleVisaExpiredChange}
                                value={visaExpired}
                            >
                                <option value="0">Select Expiration Status</option>
                                <option value="1">Expired</option>
                                <option value="2">Active</option>
                                <option value="3">Data not submitted</option>
                            </select>
                        </div>

                        <div className="cvs-actions-btns">
                            <ReactHTMLTableToExcel
                                id="subcontractorTable"
                                className="cvs-report-btn"
                                table="sub_ach_rpt"
                                filename="visa_status_report"
                                sheet="visa_status_report"
                                buttonText="Excel Export"
                            />
                            <button
                                type="button"
                                className="cvs-report-btn"
                                disabled={filteredReports?.length === 0}
                                onClick={candidateVisaExportPDF}
                            >
                                <i className="fa fa-file-pdf-o" style={{ color: "#ef4444" }}></i>
                                Export PDF
                            </button>
                        </div>
                    </div>

                    {candidateVisaReports && candidateVisaReports.length > 0 && (
                        <div className="cvs-kpi-row" style={{ marginTop: "16px" }}>
                            <div className="cvs-metric-card">
                                <div className="cvs-metric-icon" style={{ background: "rgba(99, 102, 241, 0.08)", color: "#4f46e5" }}>
                                    <i className="fa fa-users"></i>
                                </div>
                                <div>
                                    <div className="cvs-metric-val">{totalCount}</div>
                                    <div className="cvs-metric-label">Total Records</div>
                                </div>
                            </div>
                            <div className="cvs-metric-card">
                                <div className="cvs-metric-icon" style={{ background: "rgba(6, 182, 212, 0.08)", color: "#06b6d4" }}>
                                    <i className="fa fa-globe"></i>
                                </div>
                                <div>
                                    <div className="cvs-metric-val">{uniqueVisas}</div>
                                    <div className="cvs-metric-label">Visa Types</div>
                                </div>
                            </div>
                            <div className="cvs-metric-card">
                                <div className="cvs-metric-icon" style={{ background: "rgba(239, 68, 68, 0.08)", color: "#ef4444" }}>
                                    <i className="fa fa-exclamation-triangle"></i>
                                </div>
                                <div>
                                    <div className="cvs-metric-val">{expiredCount}</div>
                                    <div className="cvs-metric-label">Expired Visas</div>
                                </div>
                            </div>
                            <div className="cvs-metric-card">
                                <div className="cvs-metric-icon" style={{ background: "rgba(16, 185, 129, 0.08)", color: "#10b981" }}>
                                    <i className="fa fa-check-circle-o"></i>
                                </div>
                                <div>
                                    <div className="cvs-metric-val">{activeCount}</div>
                                    <div className="cvs-metric-label">Valid Visas</div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Synchronized top scrollbar */}
                    {candidateVisaReports && candidateVisaReports.length > 0 && filteredReports.length > 0 && (
                        <div 
                            ref={topScrollRef}
                            onScroll={handleTopScroll}
                            style={{ overflowX: "auto", overflowY: "hidden", height: "14px", width: "100%", marginBottom: "4px" }}
                        >
                            <div style={{ width: `${tableWidth}px`, height: "1px" }}></div>
                        </div>
                    )}

                    <div 
                        ref={tableWrapperRef}
                        onScroll={handleTableScroll}
                        className="cvs-report-table-wrapper"
                        style={{ position: "relative" }}
                    >
                        {isLoading && <div className="wf-loading-bar" />}

                        {isLoading ? (
                            /* SKELETON TABLE LOADING SCREEN */
                            <table className="cvs-report-table">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Name</th>
                                        <th>Email</th>
                                        <th>Phone</th>
                                        <th>Visa Type</th>
                                        <th>Visa Expiration Date</th>
                                        <th>Visa Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {[1, 2, 3, 4, 5].map((i) => (
                                        <tr key={`skel-${i}`} className="skeleton-row">
                                            <td><span className="skeleton-cell sk-short" style={{ animationDelay: `${i * 0.05}s` }} /></td>
                                            <td><span className="skeleton-cell sk-medium" style={{ animationDelay: `${i * 0.07}s` }} /></td>
                                            <td><span className="skeleton-cell sk-long" style={{ animationDelay: `${i * 0.06}s` }} /></td>
                                            <td><span className="skeleton-cell sk-medium" style={{ animationDelay: `${i * 0.08}s` }} /></td>
                                            <td><span className="skeleton-cell sk-short" style={{ animationDelay: `${i * 0.05}s` }} /></td>
                                            <td><span className="skeleton-cell sk-medium" style={{ animationDelay: `${i * 0.07}s` }} /></td>
                                            <td><span className="skeleton-cell sk-short" style={{ animationDelay: `${i * 0.05}s` }} /></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ) : candidateVisaReports && candidateVisaReports.length > 0 ? (
                            filteredReports.length > 0 ? (
                                <table
                                    className="cvs-report-table"
                                    id="sub_ach_rpt"
                                >
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Phone</th>
                                            <th>Visa Type</th>
                                            <th>Visa Expiration Date</th>
                                            <th>Visa Status</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {filteredReports.map((item) => {
                                            let visaExpirationStatus = 3;
                                            if (item.visaExpiration) {
                                                const expDate = new Date(item.visaExpiration);
                                                const today = new Date();
                                                const expDateOnly = new Date(expDate.toDateString());
                                                const todayOnly = new Date(today.toDateString());
                                                visaExpirationStatus = expDateOnly < todayOnly ? 1 : 2;
                                            }

                                            return (
                                                <tr key={item.keyId}>
                                                    <td>{item.keyId}</td>
                                                    <td>{item.keyName}</td>
                                                    <td>{item.keyEmail}</td>
                                                    <td>{item.keyPhone && getFormatedNumber(item.keyPhone)}</td>
                                                    <td>
                                                        {visaStatus.find((v) => v.value === item.visaType)?.label || 'N/A'}
                                                    </td>
                                                    <td>
                                                        {item.visaExpiration && (
                                                            <Moment format="MMM Do, YYYY">{item.visaExpiration}</Moment>
                                                        )}
                                                    </td>
                                                    <td>
                                                        {visaExpirationStatus === 1 && (
                                                            <span className="badge-expired">Expired</span>
                                                        )}
                                                        {visaExpirationStatus === 2 && (
                                                            <span className="badge-active">Active</span>
                                                        )}
                                                        {visaExpirationStatus === 3 && (
                                                            <span className="badge-none">N/A</span>
                                                        )}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            ) : (
                                <div className="wf-empty-state">
                                    <div className="wf-empty-icon">
                                        <i className="fa fa-search"></i>
                                    </div>
                                    <p className="wf-empty-title">No Matching Records</p>
                                    <p className="wf-empty-desc">No records matched your search query. Try adjusting your search term.</p>
                                </div>
                            )
                        ) : (
                            <div className="wf-empty-state">
                                <div className="wf-empty-icon">
                                    <i className="fa fa-folder-open-o"></i>
                                </div>
                                <p className="wf-empty-title">No Data Found</p>
                                <p className="wf-empty-desc">No visa status records found for this category on the server.</p>
                            </div>
                        )}
                    </div>
                </div>
            )}

            {selectedEntityType === 0 && (
                <div className="wf-empty-state" style={{ border: "1px dashed #cbd5e1", borderRadius: "12px", background: "#f8fafc" }}>
                    <div className="wf-empty-icon">
                        <i className="fa fa-info-circle"></i>
                    </div>
                    <p className="wf-empty-title">No Category Selected</p>
                    <p className="wf-empty-desc">Select a candidate category above to inspect Visa compliance reports.</p>
                </div>
            )}

            <GeneratePdf
                handlepdfShowHide={handlepdfShowHide}
                pdfShowHide={pdfShowHide}
                selectedCol={selectedCol}
                selectedColData={selectedColData}
            ></GeneratePdf>
        </div>
    );
};

export default CandidateVisaStatus;